var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useFetchPromise } from '@rad/hooks';
import { fetchInspectionTemplates, fetchOpenInvoices, startInspection } from '../../../http/inspections';
import { navigate } from '../../../utility/general';
import Button from '../../components/button';
import CSelect from '../../components/select';
import Layout from './layout';
export default (props) => {
    const [invoices, setInvoices] = React.useState(null);
    const [templates] = useFetchPromise(fetchInspectionTemplates);
    const [selectedTemplateId, setSelectedTemplateId] = React.useState(null);
    const [starting, setStarting] = React.useState(null);
    const autoStartedRef = React.useRef(false);
    const startOne = (invoiceId) => __awaiter(void 0, void 0, void 0, function* () {
        if (starting) {
            return;
        }
        try {
            setStarting(invoiceId);
            const result = yield startInspection(invoiceId, props.performerId, selectedTemplateId);
            navigate(`#/inspection-mode/${result.id}`);
        }
        finally {
            setStarting(null);
        }
    });
    React.useEffect(() => {
        fetchOpenInvoices(props.performerId, {
            'success': (data) => setInvoices(data || []),
            'error': () => setInvoices([]),
        });
    }, [props.performerId]);
    React.useEffect(() => {
        var _a;
        setSelectedTemplateId(((_a = templates === null || templates === void 0 ? void 0 : templates[0]) === null || _a === void 0 ? void 0 : _a.id) || null);
    }, [templates]);
    React.useEffect(() => {
        if (!!props.invoiceId && templates !== null && !autoStartedRef.current) {
            autoStartedRef.current = true;
            startOne(props.invoiceId);
        }
    }, [props.invoiceId, templates, selectedTemplateId]);
    return _jsxs(Layout, { title: "Pick a Job to Inspect", exitTo: props.onExit, children: [_jsxs("div", { className: "d-flex justify-content-between align-items-center mb-3", children: [_jsx("h4", { className: "text-start m-0", children: "Start New Inspection" }), _jsx(Button, { color: "secondary", onClick: () => navigate('#/inspection-mode/my-jobs'), children: "Back to My Jobs" })] }), _jsx("div", { className: "mb-3", style: { 'maxWidth': '420px' }, children: _jsx(CSelect, { value: selectedTemplateId, onChange: (x) => setSelectedTemplateId(x || null), items: templates || [], valuef: (x) => x.id, titlef: (x) => x.name, disabled: templates === null || !!starting, emptyValue: "", emptyTitle: "Standard Inspection", children: "Template" }) }), invoices === null
                ? _jsx("p", { className: "text-muted", children: "Loading..." })
                : invoices.length === 0
                    ? _jsx("p", { className: "text-muted", children: "No open invoices available." })
                    : _jsx("div", { className: "d-flex flex-column gap-3", children: invoices.map((x) => _jsxs("div", { className: "card p-3 text-center clickable", onClick: () => startOne(x.id), children: [_jsxs("h5", { className: "mb-1", children: [x.client_firstname, " ", x.client_lastname] }), _jsx("div", { className: "text-muted", children: x.vehicle_kind || 'Vehicle info unavailable' }), _jsxs("div", { className: "text-muted small", children: ["VIN: ", x.vehicle_vin || '-', " / Tag: ", x.vehicle_tag || '-'] })] }, x.id)) })] });
};
